import { Dexie } from 'dexie';

const db = new Dexie('tecneaHydrotestDb');
db.version(28).stores({
    users: '++id,username,isLoggedIn,date',
    formsData: '++id,form,date',
    materialsData: '++id,material,date',
    operationData: '++id,operation,date',
    saveFormData: '++id,formSave,date',
    submitFormData: '++id,formSave,date',
    formPdfData: '++id,formSave,date',
    translationConfigData: '++id,translationConfig,date',
})
const { formsData, materialsData, operationData, saveFormData, submitFormData, users, formPdfData, translationConfigData } = db;

export {
    formsData,
    materialsData, 
    operationData,
    saveFormData,
    submitFormData,
    users,
    formPdfData,
    translationConfigData
}